import * as Sentry from "@sentry/react";

import { isLocal } from "~/config";
import { env } from "~/env";
import {
  DENY_URLS,
  IGNORE_ERROR_PATTERNS,
  isThirdPartyNoise,
} from "./noise-filters";

if (!isLocal) {
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    tracesSampleRate: 0.5,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      new RegExp(env.VITE_SENTRY_TRACE_PROPAGATION_TARGET_REGEX),
    ],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.5,

    // Drop noise from third-party tools outside our control. See noise-filters.ts.
    ignoreErrors: IGNORE_ERROR_PATTERNS,
    denyUrls: DENY_URLS,

    beforeSend(event) {
      // Safety net for third-party noise that ignoreErrors/denyUrls may miss.
      if (isThirdPartyNoise(event)) {
        return null;
      }

      if (event.request?.url) {
        event.request.url = event.request.url.split("?")[0];
      }
      if (event.request?.query_string !== undefined) {
        event.request.query_string = "[FILTERED]";
      }
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.filter(
          (b) => !["ui.input", "console"].includes(b.category ?? ""),
        );
      }
      return event;
    },
  });
}
